// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --configuration=production` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// Use ngx-env to access environment variables at build time
const env = (process.env as any);

if (!env) {
  throw new Error('🔴 Fatal error: .env file is not available');
}

export const environment = {
  production: true,
  // API scopes for authentication
  apiScopes: [`api://${env.NG_API_CLIENT_ID}/access_as_user`],
  tenantId: env.NG_TENANT_ID,
  clientId: env.NG_CLIENT_ID,
  // Other environment variables can be accessed similarly
  apiUrl: 'https://edgar.pilet-renaud.ch',
  // Token for trusted API communication
  trustedToken: env.NG_API_TRUSTED_TOKEN,
  // Sentry DSN for error tracking
  sentryDsn: env.NG_SENTRY_DSN,
  // Production specific features
  enableDebug: false,
  logLevel: 'error',
  // Production specific MSAL settings (we use redirect instead of popup)
  // msalConfig: {
  //   navigateToLoginRequestUrl: false,
  //   popupWindowAttributes: {
  //     width: 500,
  //     height: 500
  //   }
  // }
};

console.log('--- DBG env.prod on build', environment);
